import React, { ComponentClass, PureComponent, ReactNode } from "react";
import { Mutation, MutationOptions, MutationResult } from "react-apollo";

import GetCart from "../../repository/withCart/graphql/GetCart";
import GetMe from "../../repository/withMe/graphql/GetMe";

import Login from "./graphql/Login";

export interface ILoginProps {
  login: (input: {
    email: string;
    password: string;
  }) => Promise<MutationResult<void>>;
  loginLoading: boolean;
}

interface IVariables {
  input: {
    rememberMe: boolean;
    email: string;
    password: string;
  };
}

export default <P extends object>(
  Component: React.ComponentType<P>
): ComponentClass<P> =>
  class LoginClass extends PureComponent<P> {
    public render(): ReactNode {
      return (
        <Mutation
          mutation={Login}
          update={(
            // tslint:disable-next-line: no-any
            cache: any,
            // tslint:disable-next-line: no-any
            { data: { login } }: any
          ): void => {
            cache.writeQuery({
              data: { me: login },
              query: GetMe,
            });
          }}
        >
          {(
            login: (params: MutationOptions<void, IVariables>) => void,
            data: { loading: boolean }
          ): JSX.Element => {
            return (
              <Component
                {...this.props}
                login={(input: { email: string; password: string }): void =>
                  login({
                    mutation: Login,
                    refetchQueries: [{ query: GetCart }],
                    variables: {
                      input: {
                        rememberMe: true,
                        ...input,
                      },
                    },
                  })
                }
                loginLoading={data.loading}
              />
            );
          }}
        </Mutation>
      );
    }
  };
